import { Component, OnInit, HostListener } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit {
  selectedSection: string = 'personal-info';
  isSmallScreen: boolean = false;
  showContentOnSmallScreen: boolean = false;

  constructor(private translate: TranslateService) {
    this.checkScreenSize();
  }

  ngOnInit() {
    this.checkScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.checkScreenSize();
  }

  private checkScreenSize() {
    this.isSmallScreen = window.innerWidth < 768;
  }

  selectSection(section: string) {
    this.selectedSection = section;
    if (this.isSmallScreen) {
      this.showContentOnSmallScreen = true;
    }
  }

  goBackToMenu() {
    this.showContentOnSmallScreen = false;
  }
}
